import { AuthContextProvider } from "providers/AuthProvider";
import { ConsoleStateProvider } from "./providers/ConsoleStateProvider";
import Loader from "react-loader-spinner";
import React from "react";
import { Routes } from "routes/Routes";
import { StyledMainContainer } from "styled";
import { StyledLoading } from "styled";
import { useLoadingState } from "providers/LoadingProvider";
import { ConfirmProvider } from "material-ui-confirm";

function App() {
  const { loading } = useLoadingState();
  return (
    <>
      {loading && (
        <StyledLoading>
          <Loader type="Oval" color="#00BFFF" height={100} width={100} />
        </StyledLoading>
      )}
      <AuthContextProvider>
        <ConsoleStateProvider>
          <StyledMainContainer>
            <ConfirmProvider>
              <Routes />
            </ConfirmProvider>
          </StyledMainContainer>
        </ConsoleStateProvider>
      </AuthContextProvider>
    </>
  );
}

export default App;
